export namespace AxiosRequestEnum {
  export const endpoint = Object.freeze({
    coreApi: 'CORE_API',
    backofficeApi: 'BACKOFFICE_API',
  });
}
